import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Notification } from 'app/core/topbar/models/notification.model';
import { NotificationService } from 'app/core/topbar/_services/notification.service';
import { LayoutUtilsService } from 'app/core/_base/crud';
import { Subject } from 'rxjs';



@Component({
  standalone: false,
	selector: 'kt-notification-detail',
	templateUrl: './notification-detail.component.html',
	styleUrls: ['./notification-detail.component.scss']
})
export class NotificationDetailComponent implements OnInit {

	private subject = new Subject();

	@Input() notification: Notification;

	/**
	 * Send the event order created
	 */
	@Output() notificationProcessed: EventEmitter<any> = new EventEmitter<any>();



	constructor(private notificationService: NotificationService,
		private layoutUtilsService: LayoutUtilsService,
		private dialogRef: MatDialogRef<any>) {

	}

	ngOnInit(): void {

	}


	ngOnChanges() {
		console.log(this.notification.statusFlag);

	}


	process() {
		this.notificationService.updateStatusNotification(this.notification.id).subscribe(data => {
			if (data) {
				this.showModalAlert("Notification marked as processed.");
				this.notificationProcessed.emit(true);
				this.notificationService.announceProcess(true);
			} else {
				this.showModalAlert("Notification could not be marked as processed. Please contact Administrator");
			}
			this.dialogRef.close();
		});
	}

	private showModalAlert(message: string) {
		const modalRef = this.layoutUtilsService.generalAlert();
		modalRef.componentInstance.data = message;

	}


	close() {
		this.dialogRef.close();
	}


}
